import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import AddKeywordsDrawerContent from './AddKeywordsDrawerContent';
import useDomain from '@/hooks/useDomain';
import type { GridDrawerProps } from './types';

let initialLimit = 0;

interface AddKeywordsDrawerProps extends GridDrawerProps {
  setShouldRevalidateFirstPage: (value: boolean) => void;
}

const AddKeywordsDrawer = ({
  show,
  setShow,
  gridRef,
  setShouldRevalidateFirstPage
}: AddKeywordsDrawerProps) => {
  const { domain, domain_slug } = useDomain();
  const [limitKeywords, setLimitKeywords] = useState(0);
  return (
    <Offcanvas
      onShow={() => {
        const offcanvasElement = document.querySelector('.offcanvas');
        if (offcanvasElement) {
          offcanvasElement.removeAttribute('tabindex');
        }
      }}
      show={show}
      onHide={() => {
        setShow(false);
        setLimitKeywords(initialLimit);
      }}
      style={{ backgroundColor: 'var(--falcon-body-bg)' }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="m-0">
              افزودن کلمات به <strong>{domain}</strong>
            </div>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr className="my-0" />
      <Offcanvas.Body className="pt-0">
        <AddKeywordsDrawerContent
          setShouldRevalidateFirstPage={setShouldRevalidateFirstPage}
          setShow={setShow}
          limitKeywords={limitKeywords}
          setLimitKeywords={setLimitKeywords}
          initialLimit={initialLimit}
          gridRef={gridRef}
        />
      </Offcanvas.Body>

      <style>
        {/* استایل کلی دراور */}
        {`
  .offcanvas{
     width:500px !important;
      max-width:100% !important;
    }
  .offcanvas img {
    margin: 0 auto;
    max-width: 100%;
    height: auto;
    display: flex;
    }
  .accordion-button:not(.collapsed),.accordion-button{
    color:var(--falcon-gray-900) !important;
    font-weight: 500;
    }
 `}
        *
      </style>
    </Offcanvas>
  );
};

export default AddKeywordsDrawer;
